import React from "react";
import CircularPB from "../../components-react/CircularPB";

const CFPCcards = (props) => {
  const { calories, fats, proteins, carbs } = props || {};

  return (
    <div className="cards-four-grid">
      <div className="grid-box">
        <div className="grid-box-child grid-icon-box">
          <div className="common-circular-progress">
            <CircularPB name={"calories"} value={calories?.total || 0} />
          </div>
        </div>
        <div className="grid-box-child grid-label-info-box">
          <p className="label-name">calorie (Per day)</p>
          <span className="label-info">{calories?.total || 0} KCAL</span>
        </div>
      </div>
      <div className="grid-box">
        <div className="grid-box-child grid-icon-box">
          <div className="common-circular-progress">
            <CircularPB name={"fats"} value={fats?.total || 0} />
          </div>
        </div>
        <div className="grid-box-child grid-label-info-box">
          <p className="label-name">Fat (Per day)</p>
          <span className="label-info">{fats?.total || 0} GM</span>
        </div>
      </div>
      <div className="grid-box">
        <div className="grid-box-child grid-icon-box">
          <div className="common-circular-progress">
            <CircularPB name={"proteins"} value={proteins?.total || 0} />
          </div>
        </div>
        <div className="grid-box-child grid-label-info-box">
          <p className="label-name">Protein (Per day)</p>
          <span className="label-info">{proteins?.total || 0} GM</span>
        </div>
      </div>
      <div className="grid-box">
        <div className="grid-box-child grid-icon-box">
          <div className="common-circular-progress">
            <CircularPB name={"carbs"} value={carbs?.total || 0} />
          </div>
        </div>
        <div className="grid-box-child grid-label-info-box">
          <p className="label-name">Carbs (Per day)</p>
          <span className="label-info">{carbs?.total || 0} GM</span>
        </div>
      </div>
    </div>
  );
};

export default CFPCcards;
